import Icon from "@ant-design/icons";
import { enumDrawerPlacement } from "@configs";
import { useNotify } from "@utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";
import {
    SharedComponentDrawer
} from "../shared";
const textString = "390px × 270px Maximum 10MB";

interface IProps {
    showModal: boolean;
    handleClose: () => void;
    selectedService?: any;
}

export const ComponentOrderHistoryDrawer = (props: IProps) => {
    const history = useHistory();
    const { showModal, handleClose, selectedService } = props;
    const { t } = useTranslation();
    const { success, error } = useNotify();
    const [subCategory, setSubCategory] = useState<string[]>(["sub category"]);
    const [CatName, setCatName] = useState<string>("");
    const [categoryImage, setCategoryImage] = useState<string>("");
    const dispatch = useDispatch();
    useEffect(() => {
        if (selectedService) {
            setCatName(selectedService.category);
        } else {
            setCatName("");
        }
    }, [selectedService]);

    const handleSave = async () => {
        try {
            await null;
        } catch (error) {
            //
        }
    };
    const radioStyle = {
        display: "block",
        height: "30px",
        lineHeight: "30px",
        marginBottom: 16,
    };

    const onChange = (e: any) => {
        //
    };
    return (
        <SharedComponentDrawer
            title={t("page.my_order")}
            onClose={handleClose}
            placement={enumDrawerPlacement.BOTTOM}
            visible={showModal}
            width={"auto"}
            height={"90%"}
            style={{ backgroundColor: "#323232" }}
        >
            <StyledCustomHome>
                <Icon type="close" className="closeBtn" onClick={handleClose} />
                <div className="drawerBody">
                    <div className="ServiceTitle">
                        <h1 className="topServiceTitle">Shibuya Honey Toast</h1>
                        <div className="prices">
                            <p>฿200.00</p>
                            <span>฿459.00</span>
                        </div>
                    </div>
                    <div className="imagesRow">
                        <div className="images">
                            <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                            <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                            <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                        </div>
                        <div className="statusBadge">Preparing</div>
                    </div>
                </div>
                <div className="drawerBody">
                    <div className="ServiceTitle">
                        <h1 className="topServiceTitle">Shibuya Honey Toast</h1>
                        <div className="prices">
                            <p>฿200.00</p>
                            <span>฿459.00</span>
                        </div>
                    </div>
                    <div className="imagesRow">
                        <div className="images">
                            <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                            <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                            <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                        </div>
                        <div className="statusBadge">Preparing</div>
                    </div>
                </div>
                <div className="drawerBody">
                    <div className="ServiceTitle">
                        <h1 className="topServiceTitle">Shibuya Honey Toast</h1>
                        <div className="prices">
                            <p>฿200.00</p>
                            <span>฿459.00</span>
                        </div>
                    </div>
                    <div className="imagesRow">
                        <div className="images">
                            <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                            <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                            <img src="https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg" />
                        </div>
                        <div className="statusBadge">Preparing</div>
                    </div>
                </div>
            </StyledCustomHome>
        </SharedComponentDrawer>
    );
};

const StyledCustomHome = styled.div`
    .addToCartBtnRow {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 20px;
        background: #ffffff;
        box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.08);
    }
    .addToCartBtn {
        background: #f22f46;
        border-radius: 74px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 19px 32px;
        gap: 20px;
        span {
            color: #fff;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
        }
        price {
            font-weight: 400;
            font-size: 12px;
            line-height: 19px;
            color: #fff;
        }
    }
    .leftSide {
        width: 50%;
        justify-content: space-evenly;
        display: flex;
        span {
            font-weight: 500;
            font-size: 20px;
            line-height: 27px;
            text-align: center;
            color: #000;
        }
    }
    .priceAndArrow {
        .oldPrice {
            font-weight: 300;
            font-size: 10px;
            line-height: 16px;
            text-align: center;
            text-decoration-line: line-through;
            color: #a0a4ab;
        }
    }
    .discountBadge {
        background: #49c549;
        border-radius: 34px;
        padding: 0px 4px;
        font-weight: 300;
        font-size: 8px;
        line-height: 13px;
        text-align: center;
        color: #ffffff;
        place-self: center;
    }
    .priceAndDiscountRow {
        display: flex;
        gap: 5px;
    }
    .ant-input::placeholder {
        font-size: 14px;
    }
    .topBackTitle {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #ffffff;
        position: absolute;
        top: 0;
    }
    .drawerBody .topServiceTitle {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 0;
    }
    .drawerBody {
        border-bottom: 0.5px solid #e1e1e1;
        .ServiceTitle {
            display: flex;
            justify-content: space-between;
            .prices {
                text-align: end;
            }
            p {
                font-weight: 400;
                font-size: 14px;
                line-height: 22px;
                color: #000000;
                margin-bottom: 0;
            }
            span {
                font-weight: 300;
                font-size: 10px;
                line-height: 16px;
                text-align: center;
                text-decoration-line: line-through;
                color: #9b9b9b;
            }
        }
        img {
            width: 42px;
            height: 42px;
            border-radius: 4px;
            margin-right: 10px;
        }
        .imagesRow {
            display: flex;
            justify-content: space-between;
            .statusBadge {
                background: #ffe9b0;
                border-radius: 60px;
                padding: 4px 8px;
                font-weight: 400;
                font-size: 10px;
                line-height: 16px;
                color: #ff9900;
                place-self: center;
            }
        }
    }
`;
